import React from 'react';

import Item from './Item';
import styles from './List.scss';

export const TEST_NAME_LIST = 'TEST_NAME_LIST';

interface ListProps {
  items: {
    id?: string;
    text?: string;
    ref?: {
      current?: Element;
    };
    defaultPosition?: number;
    position?: number;
    selected?: {
      id?: string;
      text?: string;
    };
  }[];
  setAriaLiveMessage: (...args: unknown[]) => unknown;
  setItemRef: (...args: unknown[]) => unknown;
  setListRef: (...args: unknown[]) => unknown;
  updatePositions: (...args: unknown[]) => unknown;
  setAriaLiveMessageForLiveRegion: (...args: unknown[]) => unknown;
}

export default function List(props: ListProps) {
  const {
    items,
    setAriaLiveMessage,
    setItemRef,
    setListRef,
    updatePositions,
    setAriaLiveMessageForLiveRegion
  } = props;

  const renderable = items.map(({ id, selected, text }, idx, arr) => (
    <Item
      id={id}
      key={id}
      optionsLength={arr.length}
      selected={selected}
      setAriaLiveMessage={setAriaLiveMessage}
      setAriaLiveMessageForLiveRegion={setAriaLiveMessageForLiveRegion}
      setItemRef={setItemRef}
      text={text}
      updatePositions={updatePositions}
      defaultPosition={idx}
    />
  ));

  return (
    <div className={styles.list} data-test-name={TEST_NAME_LIST} ref={setListRef}>
      {renderable}
    </div>
  );
}
